import React, { useCallback, useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
} from 'react-router-dom';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Observer from 'react-intersection-observer';
import Typography from '../Typography/CustomTypography';
import { LogoutRequested } from '../../actions/Auth';
import { getSettingCustomTextRequested } from '../../actions/AdminSettingCustom';
import { ClearGetDetailCompanyOrganizerForSideBar, GetDetailCompanyOrganizerForSideBarRequested } from '../../actions/CompanyManagementOrganizer';
import { LogOutIcon, SurveyIcon } from '../Icons/Icon';
import styles from '../../assets/jss/components/userSideBarStyle';
import FormDialog from '../Dialog/FormDialog';
import Advertisement from '../Advertisement/Advertisement';
import Button from '../Button/CustomButton';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import { changeLanguageActions } from '../../actions/Locale';

const useStyles = makeStyles(styles);

const OrganizerSidebar = (props) => {
    const classes = useStyles();

    const {
        color,
        image,
        eventInfo,
        routes,
        logOut,
        isAuthorized,
        isWeakAuth,
        isUser,
        isOpenToggle,
        handleDrawerToggle,
        organizerLiveStream,
        organizerType,
        fetchClearGetDetailCompanyOrganizerForSideBar,
        dataAuthorized,
        getDetailCompanyForSideBar,
        eventCurrent,
        organizerBooth,
        fetchGetCustomText,
        changeLanguage,
    } = props;

    const match = useRouteMatch();
    const params = useParams();
    const history = useHistory();
    const [listRoutes, setListRoutes] = useState([]);
    const [isOpenEndDialog, setIsOpenEndDialog] = useState(false);
    const [classFixed, setClassFixed] = useState('');

    const activeRoute = useCallback((routeName) => match.path.indexOf(routeName) > -1, [match]);

    useEffect(() => {
        const cookies = new Cookies();
        if (params.shortName !== cookies.get('osesen') && !_.isUndefined(cookies.get('osesen')) && params.shortName) {
            logOut();
            history.push(`/${params.shortName}/home`);
        }
    }, [params.shortName, eventCurrent]);

    useEffect(() => {
        let temp = routes;

        if (!eventInfo.has_exhibition) {
            const exhibitionRoutes = [
                '/product-management',
            ];
            temp = temp.filter((route) => !exhibitionRoutes.includes(route.path));
        }

        if (!eventInfo.has_live_stream) {
            const liveStreamRoutes = [
                '/livestream-management',
            ];
            temp = temp.filter((route) => !liveStreamRoutes.includes(route.path));
        }

        if (!eventInfo.has_seminar) {
            const seminarRoutes = [
                '/seminar-management',
            ];
            temp = temp.filter((route) => !seminarRoutes.includes(route.path));
        }

        if (!eventInfo.display_ads) {
            const adsRoutes = [
                '/advertisement-register',
            ];
            temp = temp.filter((route) => !adsRoutes.includes(route.path));
        }

        if (organizerType !== 3) {
            if (organizerType !== 1) {
                const exhibitionRoutes = [
                    '/product-management',
                ];
                temp = temp.filter((route) => !exhibitionRoutes.includes(route.path));
            }
            if (organizerType !== 2) {
                const seminarRoutes = [
                    '/seminar-management',
                ];
                temp = temp.filter((route) => !seminarRoutes.includes(route.path));
            }
        }

        if (!organizerLiveStream) {
            const liveStreamRoutes = [
                '/livestream-management',
            ];
            temp = temp.filter((route) => !liveStreamRoutes.includes(route.path));
        }

        if (!(+organizerBooth === 4 && isWeakAuth === '' && eventInfo.has_shopping_cart)) {
            const exhibitionRoutes = [
                '/setting-sell-product',
            ];
            temp = temp.filter((route) => !exhibitionRoutes.includes(route.path));
        }

        setListRoutes(temp);
    }, [eventInfo, routes, organizerType, organizerLiveStream, organizerBooth, isWeakAuth]);

    useEffect(() => {
        if (_.isEmpty(dataAuthorized)) fetchClearGetDetailCompanyOrganizerForSideBar();
        else if (isAuthorized && !_.isEmpty(dataAuthorized)) getDetailCompanyForSideBar();
    }, [dataAuthorized, fetchClearGetDetailCompanyOrganizerForSideBar, getDetailCompanyForSideBar, params.shortName, isAuthorized]);

    useEffect(() => {
        if (history.location.pathname && params.shortName) {
            const textTypeRoute = routes.find((item) => {
                if (history.location.pathname.includes(item.path)) return item;
                return null;
            });
            if (!_.isEmpty(textTypeRoute) && !_.isUndefined(textTypeRoute.text_type)) {
                fetchGetCustomText({ eventShortName: params.shortName, site: 1, text_type: textTypeRoute.text_type });
            }
        }
    }, [params.shortName, history.location.pathname]);

    useEffect(() => {
        const googleIframe = document.getElementById(':1.container')?.contentWindow.document.getElementById(':1.close');
        changeLanguage('ja');
        if (isAuthorized && googleIframe) {
            googleIframe.click();
        }
    }, [isAuthorized]);

    const handleLogOutSystem = () => {
        if (logOut) {
            if (eventInfo.done_language_config) {
                const focusLanguage = sessionStorage.getItem('selectedLang');
                if (focusLanguage !== '日本語' && focusLanguage !== 'English') {
                    sessionStorage.setItem('selectedLang', 'English');
                }
            }
            logOut();
            changeLanguage('ja');
            history.push(`/${params.shortName}/home`);
            window.location.reload();
        }
    };

    const handleBackHomePage = () => {
        changeLanguage('ja');
        history.push(`/${params.shortName}/organizer/home`);
    };
    const handleChange = (intersection) => {
        if (intersection) {
            setClassFixed('');
        } else {
            setClassFixed('fixedSidebar');
        }
    };
    const handleClose = () => {
        if (logOut) {
            logOut();
            setIsOpenEndDialog(false);
            history.push(`/${params.shortName}/home`);
        }
    };
    const handleCloseDialog = () => {
        setIsOpenEndDialog(false);
    };

    const handleRedirectSurvey = () => {
        window.open(eventInfo.survey_link_organizer, '_blank');
    };

    const options = {
        threshold: 1,
        rootMargin: '0px',
        onChange: handleChange,
    };

    const renderSurveyLink = (isMobileMode) => {
        if (!isAuthorized || !isUser) return null;

        if (!eventInfo.survey_link_organizer) return null;

        return (
            <div className={classes.item}>
                <ListItem
                    button
                    onClick={() => {
                        if (isMobileMode) {
                            handleDrawerToggle();
                        }
                        handleRedirectSurvey();
                    }}
                    className={classes.itemLink}
                >
                    <SurveyIcon />
                    <ListItemText
                        primary={eventInfo?.settings_texts_sidebar_organizer?.field_name?.survey || 'アンケート'}
                        className={classNames(classes.itemText)}
                        disableTypography
                    />
                </ListItem>
            </div>
        );
    };

    const links = (isMobileMode) => (
        <List className={classes.list}>
            {
                listRoutes.map((prop) => {
                    const listItemClasses = classNames({
                        [` ${classes[color]}`]: activeRoute(`${prop.param}${prop.path}`),
                    });
                    const whiteFontClasses = classNames({
                        [`${classes.whiteFont}`]: activeRoute(`${prop.param}${prop.path}`),
                    });
                    return (
                        <NavLink
                            to={`/${params.shortName}${prop.path}`}
                            text={prop.name}
                            className={classes.item}
                            activeClassName="active"
                            exact
                            isActive={prop.isActiveFunc}
                            key={prop.path}
                            onClick={isMobileMode ? handleDrawerToggle : () => { }}
                        >
                            <ListItem button className={classes.itemLink + listItemClasses}>
                                <prop.icon />
                                <ListItemText
                                    primary={(eventInfo?.settings_texts_sidebar_organizer?.field_name?.[prop.customName] || prop.name)}
                                    className={classNames(classes.itemText, whiteFontClasses)}
                                    disableTypography
                                />
                            </ListItem>
                        </NavLink>
                    );
                })
            }
            {renderSurveyLink(isMobileMode)}
            <div className={classes.logOutButton}>
                <ListItem
                    button
                    className={`${classes.itemLink} ${classes.orange}`}
                    onClick={() => {
                        if (isMobileMode) {
                            handleDrawerToggle();
                        }
                        handleLogOutSystem();
                    }}
                >
                    <LogOutIcon />
                    <ListItemText
                        primary={eventInfo?.settings_texts_sidebar_organizer?.field_name?.logout || <FormattedMessage id="logout" />}
                        className={classNames(classes.itemText)}
                        disableTypography
                    />
                </ListItem>
            </div>
        </List>
    );

    return (
        <>
            <FormDialog isOpen={isOpenEndDialog} handleClose={handleCloseDialog}>
                <GridContainer style={{ marginTop: '60px' }} justify="center">
                    <GridItem>
                        <Typography style={{ textAlign: 'center' }} bold variant="h5" color="navy">
                            {eventInfo.name}
                            展示会
                        </Typography>
                    </GridItem>
                    <GridItem>
                        <Typography style={{ textAlign: 'center' }} bold variant="h5" color="navy">
                            ご来場ありがとうございました。
                        </Typography>
                    </GridItem>
                </GridContainer>
                <GridContainer style={{ marginTop: '60px' }} justify="center">
                    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                        <Button
                            onClick={handleClose}
                            color="navy"
                            size="md"
                            className={classes.buttonBig}
                        >
                            終了
                        </Button>
                    </Box>
                </GridContainer>
                {
                    eventInfo.display_ads && (
                        <GridContainer style={{ marginTop: '60px' }} justify="center">
                            <Advertisement />
                        </GridContainer>
                    )
                }
            </FormDialog>
            <Hidden mdUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor="right"
                    open={isOpenToggle}
                    classes={{
                        paper: classNames(classes.drawerPaper),
                    }}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <div className={classes.logo}>
                        <Typography
                            variant="h4"
                            color="white"
                            bold
                            onClick={() => {
                                handleBackHomePage();
                            }}
                            className={classes.brand}
                        >
                            XPAND
                        </Typography>
                    </div>
                    <div className={classes.sidebarWrapper}>
                        {links(true)}
                    </div>
                    <div
                        className={classes.background}
                        style={{ backgroundImage: `url(${image})` }}
                    />
                </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
                <Observer {...options} />
                <Drawer
                    anchor="left"
                    variant="permanent"
                    open
                    classes={{
                        paper: classNames(classes.drawerPaper, classes[classFixed]),
                        docked: classNames(classes.docked),
                    }}
                >
                    <div className={classNames(classes.sidebarWrapper)}>
                        {links(false)}
                    </div>
                    <div
                        className={classes.background}
                        style={{ backgroundImage: `url(${image})` }}
                    />
                </Drawer>
            </Hidden>
        </>
    );
};

OrganizerSidebar.defaultProps = {
    color: 'blue',
    isAuthorized: false,
    isUser: false,
    isOpenToggle: false,
    image: '',
    routes: {},
    eventInfo: {},
    userData: {},
    eventCurrent: '',
    organizerBooth: undefined,
    dataAuthorized: {},
    changeLanguage: () => {},
};

OrganizerSidebar.propTypes = {
    color: PropTypes.string,
    image: PropTypes.string,
    routes: PropTypes.oneOfType([() => null, PropTypes.array]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    userData: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.bool,
    isOpenToggle: PropTypes.bool,
    isUser: PropTypes.bool,
    logOut: PropTypes.func.isRequired,
    handleDrawerToggle: PropTypes.func.isRequired,
    organizerLiveStream: PropTypes.bool.isRequired,
    organizerType: PropTypes.string.isRequired,
    eventCurrent: PropTypes.string,
    organizerBooth: PropTypes.number,
    dataAuthorized: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchClearGetDetailCompanyOrganizerForSideBar: PropTypes.func.isRequired,
    getDetailCompanyForSideBar: PropTypes.func.isRequired,
    isWeakAuth: PropTypes.oneOfType([() => PropTypes.bool, PropTypes.string]).isRequired,
    fetchGetCustomText: PropTypes.func.isRequired,
    changeLanguage: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    logOut: () => {
        dispatch(LogoutRequested());
    },
    fetchClearGetDetailCompanyOrganizerForSideBar: () => {
        dispatch(ClearGetDetailCompanyOrganizerForSideBar());
    },
    getDetailCompanyForSideBar: () => {
        dispatch(GetDetailCompanyOrganizerForSideBarRequested());
    },
    fetchGetCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    changeLanguage: (param) => {
        dispatch(changeLanguageActions(param));
    },
});
const mapStateToProps = (state) => ({
    eventInfo: state.registration.registrationViewer.data,
    isAuthorized: state.auth.credential.isAuthorized,
    isWeakAuth: state.auth.credential.data?.isWeakAuth,
    dataAuthorized: state.auth.credential.data,
    userData: state.auth.credential.data,
    organizerType: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_type,
    organizerLiveStream: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_live_stream,
    eventCurrent: state.auth.credential.data?.event,
    organizerBooth: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.user.organizer_booth,
});
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizerSidebar);
